import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import cx from 'classnames';

import { AutomationTrigger } from '@business/entities/automation';
import { openTriggerModal } from '../AutomationTriggerModal';
import useTriggerChange from '../hooks/useTriggerChange';

export const TriggerNode = ({ id, data }: NodeProps<AutomationTrigger>) => {
  const onSelect = useTriggerChange(id);
  return (
    <div
      title={data.description}
      onClick={() => {
        openTriggerModal({ onSelect });
      }}
      className={cx('node trigger')}
    >
      <i className={data.icon}></i>
      {data.name}
      <Handle className={'handle'} type="source" position={Position.Bottom} isConnectable={false} />
    </div>
  );
};
